<template>
  <div class="view pa24">
    <div class="cA1 fs9 mb20 fwbold">{{ $t('miniprogram', 'topBgColorConfig') }}</div>
    <div class="d-flex align-items-center pl30 mb20">
      <p class="cA3">{{ $t('miniprogram', 'selectTopBgColor') }}</p>
      <div class="w100 h40 bced br5 ml20" :style="{background:color}">
      </div>
      <div class="d-flex flex-column justify-content-between ml20">
        <p>
          {{ $t('miniprogram', 'defaultBgColorNote') }}
        </p>
        <p class="cA1">
          {{ $t('miniprogram', 'bgColorNote') }}
        </p>
      </div>
    </div>
    <div class="pl30">
      <sketch-picker v-model="color" @input="colorValueChange"></sketch-picker>
    </div>
    <div class="pl30 mt20"> 
      <el-button size="small"
                 type="primary" 
                 @click="saveColorValue">
            {{ $t('miniprogram', 'save') }}
      </el-button>
    </div>
    
  </div>
</template>

<script>
import {
  addColorValue,
  queryColorValue,
  getCompany
} from "@/api/miniProgram"
import { Sketch } from 'vue-color'
import i18nMixin from '@/mixins/i18nMixin'

export default {
  components: {'sketch-picker':Sketch},
  mixins: [i18nMixin],
  data() {
    return {
      color: '#ffffff',
      companyInfo:''
    };
  },
  async created(){
    let result = await getCompany()
    this.companyInfo = result.data
    this.queryColorValue()
  },
  methods:{
    // 颜色值改变事件处理
    colorValueChange (val) {
      // 取颜色对象的十六进制值
      this.color = val.hex
    },
    queryColorValue(){
      let data = {
        companyId:this.companyInfo.companyId
      }
      queryColorValue(data)
      .then(res=>{
        console.log(res)
        this.color = res.data.colorValue
      })
    },
    saveColorValue(){
      let data = {
        colorValue:this.color,
        companyId:this.companyInfo.companyId
      }
      addColorValue(data)
      .then(res=>{
        console.log(res)
        if(res.code == 200){
          this.$message.success(this.$t('miniprogram', 'save'))
        }
      })
      .catch(err=>{
        this.$message.error(this.$t('miniprogram', 'submitFailed'))
      })
    }
  },
  
  
};
</script>

<style lang="scss" scoped>

</style>
